import type { ComponentType } from "react";
import { unique } from "util/support";
import type { CsvValue, SetupValueProps } from "../../types";

export const withUnique = <TProps extends SetupValueProps<CsvValue>>(Component: ComponentType<TProps>) =>
    (props: TProps) => (
        <Component
            {...props}
            onChange={values => (
                props.onChange!(unique(values))
            )}
        />
    );

export default withUnique;
